// The service counts a list in groups (CountDevices, CountUsers, CountOrgs):
// every combination that has a row, with how many. A page sums the groups
// it needs, so its numbers are of the whole list without loading it.

import type { DeviceCount } from '@motionsafe/ms-console-api/admin/v1/device_pb.js';
import type { OrgCount } from '@motionsafe/ms-console-api/admin/v1/org_pb.js';
import type { UserCount } from '@motionsafe/ms-console-api/admin/v1/user_pb.js';

const tally = <G>(size: (g: G) => number) => (groups: readonly G[], keep: (g: G) => boolean = () => true): number =>
  groups.reduce((n, g) => (keep(g) ? n + size(g) : n), 0);

/** How many devices are in the groups `keep` keeps. */
export const devicesIn = tally<DeviceCount>((g) => g.devices);
/** How many people are in the groups `keep` keeps. */
export const usersIn = tally<UserCount>((g) => g.users);
/** How many organizations are in the groups `keep` keeps. */
export const orgsIn = tally<OrgCount>((g) => g.orgs);
